import {Component, Input, OnInit} from '@angular/core';

import {EventService, FileHelperService} from '../../../../core';
import {AuthUser, TokenService} from '../../../../core/auth';
import {AuthService} from '../../../../core/auth/auth.service';

import {ProfileService, UserService} from '../../../../core/services';
import {User} from '../../../../core/models';
import {ProjectSidebarService} from '../../../../projectsidebar.service';
import {BreadcrumbService} from '../../../../breadcrumb.service';
import {TopbarService} from '../../../../topbar.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {PasswordPolicyValidator} from '../../../../shared/password-policy.validator';
import {MustMatchValidator} from '../../../../shared/must-match.validator';
import {MustNotMatchValidator} from '../../../../shared/must-not-match.validator';
import {ConfirmationService} from 'primeng/api';

@Component({
  selector: 'app-profile-details',
  templateUrl: './profile-details.page.html'
})
export class ProfileDetailsPage implements OnInit {
  authUser: AuthUser = this.tokenService.whoAmI();
  @Input() user: User;
  form: FormGroup;

  token = this.tokenService.getToken();

  saving = false;

  constructor(
    private tokenService: TokenService,
    private profileService: ProfileService,
    private eventService: EventService,
    private fileHelperService: FileHelperService,
    private authService: AuthService,
    private userService: UserService,
    private projectSidebarService: ProjectSidebarService,
    private breadcrumbService: BreadcrumbService,
    private topbarService: TopbarService,
    private formBuilder: FormBuilder,
    private confirmationService: ConfirmationService
  ) {
  }

  ngOnInit() {
    this.projectSidebarService.setProject(null);
    this.profileService.get().subscribe(
      (data) => {
        this.user = data;
        this.loadForm(this.user);
      }
    );
    this.breadcrumbService.setItems([
      {label: 'profile'},
    ]);

  }

  loadForm(user: User) {
    this.form = this.formBuilder.group({
      userName: [this.user.name, Validators.required],
      userEmail: [this.user.email, [Validators.required, Validators.email]],
      password: ['', [PasswordPolicyValidator]],
      confirmPassword: ['']
    }, {
      validators: [
        MustMatchValidator('password', 'confirmPassword'),
        MustNotMatchValidator('password', ['userName', 'userEmail'], null)]
    });
  }

  refresh() {
    this.authService.refresh().subscribe(
      (data) => {
        this.tokenService.saveToken(data.token);
        this.authUser = this.tokenService.whoAmI();
      }
    );
  }

  showSwitchToCustomer() {
    return this.authUser.loginCustomer.name != this.authUser.currentCustomer.name;
  }

  switchToCustomer() {
    this.authService.switchCustomer(this.authUser.username, this.authUser.loginCustomer.name).subscribe(
      (data) => {
        this.tokenService.saveToken(data.token);
        this.authUser = this.tokenService.whoAmI();
        this.topbarService.setCustomerItems(this.authUser.currentCustomer);
      }
    );

  }

  copy(field) {
    const range = document.createRange();
    range.selectNodeContents(field);
    const selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
    document.execCommand('copy');
  }

  encode(plain: any) {
    return btoa(plain);
  }

  decode(encoded: any) {
    return atob(encoded);
  }

  removeImage() {
    delete (this.user.image);
  }

  storeFile(event, element) {
    const file = event.files[0];
    if (!file.type.startsWith('image/')) {
      this.eventService.warn('invalid content, please uplaod an image');
      element.clear();
      return;
    }
    this.fileHelperService.fileToDataUrl(file, (data) => {
      this.user.image = data;
    });
  }

  saveUser() {
    this.saving = true;

    // copy the respective values from the form to the user object
    this.user.name = this.form.controls.userName.value;
    this.user.email = this.form.controls.userEmail.value;
    this.user.password = null;

    // this.extractRoles();
    this.updateUser(this.user);
  }

  updateUser(user: User) {
    this.saving = true;
    this.profileService.update(user)
      .subscribe(
        (data) => {
          delete (this.saving);
          this.user = data;
          this.topbarService.setAvatarItems(data);
          this.loadForm(this.user);
        },
        (error) => {
          delete (this.saving);
        }
      );

  }

}
